<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">
    <CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active ? '' : item.path"
      :active="item.active"
    >
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import routerPublisher from '@/publisher/router'

export default {
  name: 'PublisherBreadcrumb',

  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
      return routerPublisher.currentRoute.value.matched
        .filter((route) => {
          return route.name && route.name !== ''
        })
        .map((route) => {
          return {
            active: route.path === routerPublisher.currentRoute.value.fullPath,
            name: route.name,
            path: `${routerPublisher.options.history.base}${route.path}`,
          }
        })
    }

    routerPublisher.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
}
</script>
